// extracted by mini-css-extract-plugin
module.exports = {"unassigned":"AssignedDriver__unassigned--1or4-"};